import { createFileRoute } from '@tanstack/react-router'

import type { PerfilId } from '@/lib/visoes'

import { PaginaTarefasParadas } from '@/features/tarefas-paradas/pagina'

export const Route = createFileRoute('/$perfil/tarefas-paradas')({
  component: Tela,
})

function Tela() {
  const { perfil } = Route.useParams()
  return <PaginaTarefasParadas perfil={perfil as PerfilId} />
}
